import styled from "styled-components"

export const ActionButton = styled.button`
  &.extra-margin-top {
    margin-top: 1rem;
  }
`
